export default __webpack_public_path__ + "static/media/HowItWorks_Step3_EN.bdfb3ac3.png";